import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Http, Headers } from '@angular/http';
import { AngularFireDatabase } from '@angular/fire/database';
@Component({
  selector: 'app-tffailure',
  templateUrl: './tffailure.page.html',
  styleUrls: ['./tffailure.page.scss'],
})
export class TffailurePage implements OnInit {
  token:any;
  rstdata:any;
  constructor(public http:Http,private afDB: AngularFireDatabase,
    private route: ActivatedRoute) {
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.initpoli();
   }
  
  ngOnInit() {
  }

  initpoli(){
    var selfurl = "https://www.channel.cafe";
    var apiUrl = 'https://stark-sands-51177.herokuapp.com/https://poliapi.apac.paywithpoli.com/api/v2/Transaction/GetTransaction?token=' + this.token;
    var data ={};

    new Promise((resolve, reject)=>{
    let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append('Authorization', 'Basic UzYxMDQyNTU6N1d6QFJtXjl0JDJMU3c=');
        headers.append("cache-control", "no-cache");
        this.http.get(apiUrl, {headers: headers})
            .subscribe(res => {             
              this.rstdata = res;
              if(this.rstdata.MerchantData && this.rstdata.MerchantData.split('#@#').length == 2)
              {
                this.http.post(
                  'https://stark-sands-51177.herokuapp.com/https://us-central1-localnews-e350b.cloudfunctions.net/changeExState?idt=' + this.rstdata.MerchantData.split('#@#')[0] + 
                  '&item=' + this.rstdata.MerchantData.split('#@#')[1] + '&state=failed', null
                ).subscribe(re => {
                      resolve(re);
                  }, (err) => {
                      reject(err);
                  });
              }
             //   this.afDB.database.ref('/servicelist/forex/' + this.rstdata.MerchantData.split('#@#')[0] + '/transaction/' + this.rstdata.MerchantData.split('#@#')[1] + '/state').set('success');
             //this.navCtrl.navigateForward(['/payment', {url:res.NavigateURL}]);
            //this.confirmlink(res.json['NavigateURL']);
            //document.getElementsByTagName("ion-content")[0].innerHTML = JSON.stringify(res.json);
            resolve(res);
            }, (err) => {
            console.log(err);
            reject(err);
            });
        })
  }

}
